import request from '@/utils/request'
import { formatTimeByDate } from '@/utils'
const portal = context.portal
const form = window.context.form
import { saveAs } from 'file-saver'
const { bpmRunTime } = window.context

// 上传文件
export function uploadFile(data) {
  return request({
    url: `${portal}/system/file/v1/upload`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: {
      file: data,
    },
  })
}

// 文档批量下载
export function batchDownload(files) {
  const ids = files.join(',')
  const zipName = formatTimeByDate(new Date().getTime(), 'yyyy-MM-dd-HH-mm-ss')
  const queryString = `fileIds=${ids}&zipName=${zipName}`

  return request({
    url: `${portal}/system/file/v1/bathcDownloadFile?${queryString}`,
    responseType: 'arraybuffer',
  }).then(({ data, headers }) => {
    let blob = new Blob([data])
    const fileName = decodeURIComponent(
      headers['content-disposition'].split(';')[1].split('filename=')[1]
    )
    saveAs(blob, fileName)
  })
}

export function getList(data) {
  return request({
    url: '/portal/sysApp/v1/authList',
    method: 'post',
    data,
  })
}

export function getSystemOften(data) {
  return request({
    url: '/system/often',
    method: 'post',
    data,
  })
}

export function getPinyin(word) {
  return request.get(`${portal}/base/tools/v1/getPinyin?chinese=${word}&type=0`)
}
export function getFiles(fileId) {
  return request({
    url: `${portal}/file/onlinePreviewController/v1/getFileById_${fileId}`,
    method: 'get',
    responseType: 'blob',
  })
}
//首页进行用户、流程、文档搜索时，传递类型给后端做数据埋点
//首页访问常用模块记录埋点
export function addEventLog(data) {
  return request({
    url: `${bpmRunTime}/runtime/bpmIndexTaggedEventLog/v1/addEventLog`,
    method: 'post',
    data,
  })
}

//首页通知公告
export function getNotice(data) {
  return request({
    url: `${bpmRunTime}/runtime/homePage/v1/queryDocList?includeChild=false`,
    method: 'post',
    data,
  })
}
//首页规章制度
export function getRegulations(data) {
  return request({
    url: `${bpmRunTime}/runtime/homePage/v1/queryDocList`,
    method: 'post',
    data,
  })
}
//获取dms配置
export function getDmsConfig() {
  return request({
    url: `${bpmRunTime}/runtime/homePage/v1/getDmsConfig `,
    method: 'get',
  })
}

//首页常用模块
export function getCommonModules(data) {
  return request({
    url: `${form}/form/dataTemplate/v1/listJson`,
    method: 'post',
    data,
  })
}
